import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken
    },
    body: JSON.stringify(payload)
  };

  try {
    const response = await fetch(`${URI_TARIFF_PLAN}payment/reactive-payment`, opts);
    const jsonResult = await response.json();
    if (response.ok) {
      return jsonResult;
    }
    
    return Promise.reject(jsonResult.message)
  } catch (error) {
    return Promise.reject(error)
  }
};
